module.exports = __webpack_public_path__ + "img/SKWINKELNetActieGeschenkenE2A637.4a10cb2d.png";